import React, { createContext, useContext, useRef, RefObject } from 'react';
import Lenis from 'lenis';

const LenisContext = createContext<RefObject<Lenis | null>>({ current: null });

export const LenisProvider = ({ children, lenisRef }: { children: React.ReactNode; lenisRef: RefObject<Lenis | null> }) => (
  <LenisContext.Provider value={lenisRef}>{children}</LenisContext.Provider>
);

export const useLenis = () => useContext(LenisContext);
